import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";
import axios from "axios";
import Chip from "@mui/material/Chip";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import UserService from "services/UserService";
import { downloadFile } from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 1.3rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "#000000",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiAutocomplete-tag": {
      fontSize: "12px",
      fontFamily: '"Source Sans Pro",sans-serif',
      height: "24px",
    },
    "& .Mui-disabled": {
      color: "#000000",
      opacity: "1",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
  chipstyledisabled: {
    "& .MuiChip-deleteIcon	": {
      display: "none",
    },
    fontSize: "12px",
    fontFamily: '"Source Sans Pro",sans-serif',
    height: "24px",
    cursor: "pointer",
  },
  chipstyle: {
    fontSize: "12px",
    fontFamily: '"Source Sans Pro",sans-serif',
    height: "24px",
    cursor: "pointer",
    margin: "0 5px 0 5px",
  },
  chipdiv: {
    borderRadius: "4px",
    border: "1px solid #bdbdbd",
    height: "45px",
    paddingTop: "10px",
    margin: "2px 8px",
  },
  nofilediv: {
    paddingLeft: "13px",
    color: "#000000",
    paddingTop: "1px",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
}));

const downloadGED = (fileId, fileName) => async () => {
  console.log("download ged");
  axios
    .get(downloadFile(fileId), {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${UserService.getToken()}`,
      },
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};

export default function AutocompleteInputDroppable(props) {
  const {
    inputTitle,
    selected,
    list,
    handleChange,
    specialWidth,
    isRequired,
    isMultiple,
    disabled,
  } = props;

  console.log(selected);

  const onDragEnd = (result) => {
    console.log("onDragEnd", result);

    if (!result.destination) {
      return;
    }
    if (result.destination.index === result.source.index) {
      return;
    }
    const newCharts = [...selected];
    console.log("onDragEnd", newCharts);
    let chartCopy = {
      fileId: newCharts[result.source.index].fileId,
      fileName: newCharts[result.source.index].fileName,
    };
    newCharts.splice(result.source.index, 1);
    newCharts.splice(result.destination.index, 0, chartCopy);
    props.handleChange(null, newCharts);
  };

  const classes = useStyles();

  return (
    <div className={classes.input}>
      <DragDropContext onDragEnd={onDragEnd}>
        {/* <text className={classes.inputTitle}>{inputTitle}</text> */}

        {disabled ? (
          <div className={classes.chipdiv}>
            {selected.length > 0 ? (
              selected.map((file, index) => (
                <Chip
                  className={classes.chipstyle}
                  label={file.fileName}
                  onClick={downloadGED(file.fileId, file.fileName)}
                />
              ))
            ) : (
              <div className={classes.nofilediv}>{inputTitle}</div>
            )}
          </div>
        ) : (
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                //style={getListStyle(snapshot.isDraggingOver)}
              >
                <Autocomplete
                  renderTags={(value, getTagProps) => (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      {value.map((option, index) => (
                        <Draggable draggableId={"chip" + index} index={index}>
                          {(provided) => (
                            <Chip
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              variant="outlined"
                              label={option.fileName}
                              size="small"
                              {...getTagProps({ index })}
                            />
                          )}
                        </Draggable>
                      ))}
                    </div>
                  )}
                  multiple={isMultiple}
                  style={{ width: specialWidth }}
                  id={inputTitle}
                  value={selected}
                  options={list}
                  //  ChipProps={props.disabled ? {className:classes.chipstyledisabled} : {className:classes.chipstyle}}
                  getOptionLabel={(option) => option.fileName}
                  getOptionSelected={(selected, list) =>
                    selected.fileId === list.fileId
                  }
                  onChange={handleChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required={isRequired}
                      style={{ margin: "2px 8px" }}
                      variant="outlined"
                      label={inputTitle}
                    />
                  )}
                />
              </div>
            )}
          </Droppable>
        )}
      </DragDropContext>
    </div>
  );
}

AutocompleteInputDroppable.defaultProps = {
  specialWidth: "99%",
  isRequired: false,
  isMultiple: true,
};

AutocompleteInputDroppable.propTypes = {
  isMultiple: PropTypes.bool,
  isRequired: PropTypes.bool,
  specialWidth: PropTypes.string,
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleDateInputChange: PropTypes.any,
};
